module.exports = __webpack_public_path__ + "static/media/tutorial-banner.d8db7d42.png";